module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_5012.0c12638e.png";